import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    Input,
    Row,
    Label,
    ModalBody,
    Form,
    TabPane,
    TabContent,
    FormFeedback,
    FormGroup,
    ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OSelect from '../../../Components/OElements/OSelect';
import { getUtmZoneList, getGeodeticDatumList } from '../../../slices/thunks';

const CollectionCoordinatesForm = ({
    dataCoordinates,
    isEdit,
    handleToggleModal,
    isOpen,
    handleSave
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUtmZoneList());
        dispatch(getGeodeticDatumList());
    }, [dispatch]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: dataCoordinates?.name || '',
            utm_north_intake: dataCoordinates?.utm_north_intake || '',
            utm_east_intake: dataCoordinates?.utm_east_intake || '',
            utm_zone_id: dataCoordinates?.utm_zone_id || dataCoordinates?.utm_zone?._id || '',
            geodetic_datum_id: dataCoordinates?.geodetic_datum_id || dataCoordinates?.geodetic_datum?._id || '',
            latitude_intake: dataCoordinates?.latitude_intake || '',
            longitude_intake: dataCoordinates?.longitude_intake || '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Campo requerido'),
            utm_north_intake: Yup.number().required('Campo requerido'),
            utm_east_intake: Yup.number().required('Campo requerido'),
            utm_zone_id: Yup.string().required('Campo requerido'),
            geodetic_datum_id: Yup.string().required('Campo requerido'),
            latitude_intake: Yup.number(),
            longitude_intake: Yup.number(),
        }),
        onSubmit: async (values) => {
            const payload = {
                ...values,
                latitude_intake: values.latitude_intake !== '' ? Number(values.latitude_intake) : null,
                longitude_intake: values.longitude_intake !== '' ? Number(values.longitude_intake) : null,
            };
            handleSave(payload);
            validation.resetForm();
        },
    });

    return (
        <Form
            className='tablelist-form'
            onSubmit={e => {
                e.preventDefault();
                return false;
            }}
        >
            <ModalBody className='modal-body'>
                <TabContent activeTab={'1'}>
                    <TabPane tabId='1'>
                        <Row className='g-3'>
                            <Col lg={12} className='mb-3'>
                                <Label for='name' className='form-label'>
                                    Nombre Coordenada <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='name'
                                    id='name'
                                    className='form-control'
                                    type='text'
                                    value={validation.values.name || ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.name && validation.errors.name}
                                />
                                {validation.touched.name && validation.errors.name && (
                                    <FormFeedback>{validation.errors.name}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='utm_north_intake' className='form-label'>
                                    UTM Norte Captación <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='utm_north_intake'
                                    id='utm_north_intake'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.utm_north_intake ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.utm_north_intake && validation.errors.utm_north_intake}
                                />
                                {validation.touched.utm_north_intake && validation.errors.utm_north_intake && (
                                    <FormFeedback>{validation.errors.utm_north_intake}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='utm_east_intake' className='form-label'>
                                    UTM Este Captación <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='utm_east_intake'
                                    id='utm_east_intake'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.utm_east_intake ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.utm_east_intake && validation.errors.utm_east_intake}
                                />
                                {validation.touched.utm_east_intake && validation.errors.utm_east_intake && (
                                    <FormFeedback>{validation.errors.utm_east_intake}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key={`utm_zone_id`}
                                    label="Huso UTM"
                                    id="utm_zone_id"
                                    name="utm_zone_id"
                                    value={validation.values.utm_zone_id || ''}
                                    isRequired
                                    validation={validation}
                                    requestApi={() => dispatch(getUtmZoneList()).then(res => res.payload)}
                                />
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key={`geodetic_datum_id`}
                                    label="Datum Geodésico"
                                    id="geodetic_datum_id"
                                    name="geodetic_datum_id"
                                    value={validation.values.geodetic_datum_id || ''}
                                    isRequired
                                    validation={validation}
                                    requestApi={() => dispatch(getGeodeticDatumList()).then(res => res.payload)}
                                />
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='latitude_intake' className='form-label'>
                                    Latitud Captación
                                </Label>
                                <Input
                                    name='latitude_intake'
                                    id='latitude_intake'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.latitude_intake ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.latitude_intake && validation.errors.latitude_intake}
                                />
                                {validation.touched.latitude_intake && validation.errors.latitude_intake && (
                                    <FormFeedback>{validation.errors.latitude_intake}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='longitude_intake' className='form-label'>
                                    Longitud Captación
                                </Label>
                                <Input
                                    name='longitude_intake'
                                    id='longitude_intake'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.longitude_intake ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.longitude_intake && validation.errors.longitude_intake}
                                />
                                {validation.touched.longitude_intake && validation.errors.longitude_intake && (
                                    <FormFeedback>{validation.errors.longitude_intake}</FormFeedback>
                                )}
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
            <ModalFooter>
                <div className='hstack gap-2 justify-content-end'>
                    <Button
                        type='button'
                        onClick={() => {
                            handleToggleModal();
                        }} className='btn-danger btn-label'>
                        <i className="ri-close-line label-icon"></i>
                        Cancelar
                    </Button>
                    <Button
                        type='button'
                        color='primary'
                        className='btn btn-label btn-primary'
                        onClick={() => {
                            validation.handleSubmit();
                        }}
                    >
                        <i className='ri-save-line label-icon'></i>
                        Guardar
                    </Button>
                </div>
            </ModalFooter>
        </Form>
    );
};

export default CollectionCoordinatesForm;
